import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { env } from "../utils/env";

type RefreshTokenPayload = { refresh: string };
type RefreshTokenResponse = { access: string; expires_in: number };

export const useRefreshToken = () => {
  return useMutation<RefreshTokenResponse, unknown, RefreshTokenPayload>(
    (payload) => {
      return axios
        .post<RefreshTokenResponse>(
          `${env.verifyServiceUrl}user/token/refresh/`,
          payload
        )
        .then((res) => res.data);
    }
  );
};
